exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".blank-page{background-color:#fafafa;display:flex;flex-grow:1}.blank-page img{margin:auto;height:250px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/routes/blank/style.scss
// module id = 283
// module chunks = 0